/**
 * Run all scripts with `type="text/javascript"` in the given container.
 *
 * @param domSelector - The selector of the container that contains the script tags.
 * @returns void
 */
export function runInlineScripts(domSelector: string): void {
  const container = document.querySelector(domSelector)

  if (container === null) {
    return
  }

  const scriptTags = container.querySelectorAll("script")
  for (const scriptTag of scriptTags) {
    if (scriptTag.type === "text/plain") {
      continue
    }

    const scriptText = scriptTag.innerHTML

    const script = document.createElement("script")

    if (scriptText) {
      script.append(document.createTextNode(scriptText))
      scriptTag.parentNode?.replaceChild(script, scriptTag)
    } else if (scriptTag.src) {
      script.src = scriptTag.src
      script.async = false
      document.body.append(script)
    }
  }
}
